import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function CatalogPage() {
  const [params, setParams] = useSearchParams();
  const initialCat = params.get("cat") || "todos";
  const [filter, setFilter] = useState(initialCat);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (filter === "todos") {
      params.delete("cat");
    } else {
      params.set("cat", filter);
    }
    setParams(params, { replace: true });
  }, [filter, params, setParams]);

  const filtered = useMemo(() => {
    if (filter === "todos") return products;
    return products.filter((p) => p.category === filter);
  }, [products, filter]);

  const tabs = [
    { id: "todos", label: "Tudo" },
    { id: "kits", label: "Kits" },
    { id: "salgados", label: "Salgados" },
    { id: "brigadeiros", label: "Brigadeiros" },
    { id: "personalizados", label: "Personalizados" },
  ];

  return (
    <div data-testid="catalog-page" className="max-w-7xl mx-auto px-6 sm:px-8 py-16">
      <div className="max-w-3xl">
        <p className="text-xs uppercase tracking-widest text-rose-accent">Catálogo</p>
        <h1 className="font-heading text-5xl sm:text-6xl text-cocoa-dark mt-3">As nossas guloseimas</h1>
        <p className="text-cocoa-soft text-lg mt-4 leading-relaxed">
          Escolha o sabor, escolha o tamanho da caixa. Mistura à vontade — cada caixa é única.
        </p>
      </div>

      <div data-testid="flavor-info-banner" className="mt-8 grid sm:grid-cols-2 gap-4">
        <div className="bg-cream-deep border border-cocoa/10 rounded-2xl p-5">
          <p className="text-xs uppercase tracking-widest text-rose-accent">Caixa de Salgados</p>
          <p className="text-cocoa-dark font-heading text-xl mt-2 leading-snug">
            Escolha <span className="text-rose-accent">até 5 sabores</span> (caixa 50) ou <span className="text-rose-accent">até 6 sabores</span> (caixa 100)
          </p>
        </div>
        <div className="bg-cream-deep border border-cocoa/10 rounded-2xl p-5">
          <p className="text-xs uppercase tracking-widest text-rose-accent">Brigadeiros</p>
          <p className="text-cocoa-dark font-heading text-xl mt-2 leading-snug">
            Escolha <span className="text-rose-accent">até 3 sabores</span> (caixa 50) ou <span className="text-rose-accent">até 7 sabores</span> (caixa 100)
          </p>
        </div>
      </div>

      <div className="mt-10 flex flex-wrap gap-2">
        {tabs.map((t) => (
          <button
            key={t.id}
            data-testid={`filter-${t.id}`}
            onClick={() => setFilter(t.id)}
            className={`text-sm uppercase tracking-widest px-5 py-2.5 rounded-full border transition-colors ${
              filter === t.id
                ? "bg-cocoa-dark text-cream border-cocoa-dark"
                : "bg-cream text-cocoa-soft border-cocoa/15 hover:border-rose"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {filtered.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>

      {filtered.length === 0 && (
        <div className="text-center py-20 text-cocoa-soft">A carregar...</div>
      )}
    </div>
  );
}
